<template>
  <div id="onebyone-footer-wrapper" class="noto-sans-sc-font-family">
    <div id="onebyone-footer" class="mx-auto d-flex justify-space-between">
      <div id="left-footer-main-section" class="footer-section-wrapper">
        <div id="footer-support-main-section" class="d-flex justify-space-between">
          
         
            
          <div v-for="subject in footerSubjects" :key="subject.title">
            <div class="footer-section-title text-uppercase">{{subject.title}}</div>
            <div class="footer-section-content">
              
              <div
                class="footer-section-item font-size-14 mt-2"
                v-for="item in subject.items"
                :key="item.title"
              >
               
               <span
                  v-if="item.page && item.page.isComment"
                  @click="refundClick()"
                >{{item.title}}</span>

              <span
                  v-if="item.page && item.page.isWarranty"
                  @click="warrantyClick()"
                >{{item.title}}</span>

                <span
                  v-if="item.page && item.page.isCU"
                  @click="cUClick()"
                >{{item.title}}</span>

                <router-link
                  v-if="item.page && !item.page.isLink && !item.page.isComment && !item.page.isWarranty && !item.page.isCU"
                  :to="item.page.url"
                >{{item.title}}</router-link>

                  <a
                    v-else-if="item.page && item.page.isLink"
                    :href="item.page.url"
                    target="_blank"
                  >{{item.title}}</a>
                 
                <!-- <div v-else>{{item.title}}</div> -->
              </div>
            </div>
          </div>
        </div>
        <div id="footer-social-media-section" class="d-flex">
          <div id="footer-social-media-text">FOLLOW US</div>
          <a v-for="(socialMedia, index) in socialMedias" :key="index" :href="socialMedia.url">
            <div class="social-media icon-sprite" :class="socialMedia.cssClass"></div>
          </a>
        </div>
      </div>
      <div class="footer-section-wrapper" id="footer-subcribe-section">
        <div class="footer-section-title">Subscribe To Our Newsletter</div>
        <div class="footer-section-content">
          <div
            class="subscribe-description font-size-14 verdana-font-family"
          >Receive news, special promotions, new product information and exclusive content</div>
          <div id="subscribe-action">
            <input
              id="subscribe-email-box"
              type="text"
              placeholder="Enter Your Email"
              v-model="subscribeEmail"
            />
            <div id="subscribe-button" class="d-inline-flex justify-center align-center">Subscribe</div>
          </div>
          <div id="subscribe-term" class="font-size-12 font-italic">
            By clicking 'Subscribe', you agree to
            <a href="/support/terms_condition">Term of Use</a> and
            <a href="/support/privacy_policy">Privacy Policy</a>. We take your privacy seriously and never share your information
          </div>
        </div>
      </div>
    </div>
    <div
      id="footer-copyright-statement"
      class="d-flex justify-center align-center verdana-font-family"
    >{{ copyRightStatement }}</div>
  </div>
</template>

<script>
import footerMixins from "../../mixins/footerMixins";
import bus from '../../api/bus';
export default {
  mixins: [footerMixins],
  data() {
    return {
      subscribeEmail: ""
    };
  },
   methods: {
      warrantyClick(){
       let  _this = this;
      bus .$emit("showBoxGuide",true);  
      //  this.$router.replace("/support/warranty_register");
    },

    refundClick(){
      let  _this = this;
      bus .$emit("showBoxGrade",true);  
      
      // this.$router.replace("/support/refund_exchange");
    },

    cUClick(){
      let  _this = this;
      bus .$emit("showBoxCU",true); 
      //  this.$router.replace("/support/contact_us");
    },
   }
};
</script>

<style scoped>
/*to do share code with NavBard*/
.social-media {
  background-size: 350px;
  height: 30px;
  width: 30px;
  background-color: white;
  border-radius: 50%;
  margin-left: 17px;
}

.social-media-twitter {
  background-position: -285px 1px;
}

.social-media-instagram {
  background-position: -244px 1px;
}

.social-media-youtube {
  background-position: -203px 1px;
}

.social-media-facebook {
  background-position: -160px 0px;
}

#left-footer-main-section {
  position: relative;
  width: 540px;
}

#footer-subcribe-section {
  width: 300px;
}

.footer-section-wrapper {
  margin-top: 86px;
}

.footer-section-title {
  font-size: 17px;
}

.footer-section-content {
  margin-top: 20px;
}

.footer-section-item {
  position: relative;
}

.footer-section-item:hover > a {
  color: #e2211c !important;
}

.footer-section-item > a {
  transition: 0.4s;
}

.footer-section-item::before {
  transition: opacity 0.4s;
  height: 10px;
  position: absolute;
  left: -9px;
  top: 14%;
  transform: translateX(-30%);
  width: 9px;
  border-bottom: 4px solid #e2211c;
  content: "";
  opacity: 0;
}

.footer-section-item:hover::before {
  opacity: 1;
}

#footer-social-media-section {
  position: absolute;
  bottom: 52px;
}

#subscribe-action {
  margin-top: 40px;
}

#subscribe-button {
  width: 85px;
  height: 30px;
  background-color: #e2211c;
}

#subscribe-term {
  margin-top: 37px;
  margin-bottom: 52px;
  color: #979797 !important;
}

#subscribe-term > a {
  color: #979797 !important;
  transition: 0.4s;
}

#subscribe-term > a:hover {
  color: red !important;
}

input[type="text"]:focus {
  outline: none;
}

input[type="text"] {
  height: 30px;
  width: 190px;
  background-color: white;
  color: black;
  padding-left: 5px;
}

#footer-copyright-statement {
  height: 56px;
  background-color: #212121;
  color: white;
  font-size: 13px;
}

#onebyone-footer-wrapper {
  width: 100%;
  background-color: #333333;
}

#onebyone-footer {
  color: #ffffff;
  max-width: 950px;
}

a {
  color: white !important;
}
</style>
